export const analyticsEs = {
  analytics: {
    title: "Análisis",
    subtitle: "Análisis completo del rendimiento de tu granja",
    yieldPrediction: "Predicción de Rendimiento",
    historicalData: "Datos Históricos",
    trends: "Tendencias",
    comparison: "Comparación",
    export: "Exportar Informe",
    dateRange: "Rango de Fechas",
    thisWeek: "Esta Semana",
    thisMonth: "Este Mes",
    thisYear: "Este Año",
    custom: "Personalizado",
    ndviTrend: "Tendencia NDVI",
    weatherImpact: "Impacto Climático",
    cropPerformance: "Rendimiento del Cultivo",
    recommendations: "Recomendaciones"
  },
  analyticsUnified: {
    title: "Análisis e Informes",
    subtitle: "Análisis completo, insights de IA e informes profesionales",
    tabBasic: "Análisis Básico",
    tabAI: "Insights IA",
    tabReports: "Centro de Informes"
  },
  analyticsPage: {
    title: "Analítica Básica",
    subtitle: "Información esencial de parcelas y métricas de monitoreo actuales",
    farmerDashboard: "Panel Agricultor",
    urbanManagerDashboard: "Panel Gestor Urbano",
    insurerDashboard: "Panel Asegurador",
    generateNDVIHistory: "Generar Historial NDVI",
    runAnalyticsPipeline: "Ejecutar Pipeline de Analítica",
    starting: "Iniciando...",
    generating: "Generando...",
    parcels: "Parcelas",
    weather: "Clima",
    irrigation: "Riego",
    fertilizer: "Fertilizante",
    riskEur: "Riesgo €",
    harvestEur: "Cosecha €",
    pac: "PAC",
    parcelOverview: "Resumen de Parcela y Estadísticas",
    selected: "Seleccionada",
    parcelDescription: "Información detallada de la parcela y métricas clave para análisis agrícola",
    locationDetails: "Detalles de Ubicación",
    coordinates: "Coordenadas",
    area: "Superficie",
    hectares: "hectáreas",
    cropType: "Tipo de Cultivo",
    notSpecified: "No especificado",
    agriculturalData: "Datos Agrícolas",
    plantingSeason: "Temporada de Siembra",
    expectedHarvest: "Cosecha Esperada",
    growingStage: "Etapa de Crecimiento",
    keyMetrics: "Métricas Clave",
    ndviHealthScore: "Puntuación NDVI de Salud",
    lastData: "Últimos datos",
    daysAgo: "días atrás",
    noSatelliteData: "Sin datos satelitales",
    runPipeline: "Ejecutar pipeline",
    riskLevel: "Nivel de Riesgo",
    unknown: "Desconocido",
    insuranceStatus: "Estado del Seguro",
    environmentalConditions: "Condiciones Ambientales",
    noEnvironmentalData: "Sin datos ambientales disponibles aún",
    runAnalyticsToCollect: "Ejecuta la analítica para recopilar condiciones meteorológicas",
    temperature: "Temperatura",
    humidity: "Humedad",
    windSpeed: "Velocidad del Viento",
    precipitation: "Precipitación",
    noRain: "Sin lluvia",
    rain: "Lluvia",
    recentRain: "Lluvia reciente",
    noParcelSelected: "Sin parcela seleccionada. Añade una parcela primero o selecciona una de tu lista.",
    currentEnvironmentalConditions: "Condiciones Ambientales Actuales",
    selectParcelToView: "Selecciona una parcela para ver las condiciones actuales",
    selectParcelIrrigation: "Selecciona una parcela del menú para ver recomendaciones de riego",
    selectParcelNitrogen: "Selecciona una parcela para ver optimización de nitrógeno",
    errorLoadingAnalytics: "Error cargando analítica",
    noAnalyticsAvailable: "Sin analítica disponible",
    runPipelineDesc: "Ejecuta el pipeline de analítica para generar datos de esta parcela",
    pipelineStarted: "Proceso iniciado",
    pipelineStartedDesc: "Los datos aparecerán en unos minutos. Puedes refrescar la página.",
    errorGeneratingHistory: "Error generando historial",
    couldNotComplete: "No se pudo completar",
    startingPipeline: "Iniciando pipeline de analítica",
    generatingAnalytics: "Generando analítica completa para",
    analyticsUpdated: "¡Analítica actualizada!",
    allMetricsGenerated: "Todas las métricas generadas correctamente para",
    pipelineFailed: "Pipeline fallido",
    couldNotGenerate: "No se pudo generar analítica",
    analysisComplete: "Análisis Completado",
    analysisError: "Error de Análisis",
    failedToGenerate: "Error al generar datos satelitales. Inténtalo de nuevo.",
    analysisWarning: "Advertencia de Análisis"
  }
};
